import { Log } from "../utils";
import { ArticleItem } from "./ArticleItem";
import { ItemUpdateFlags } from "./BaseItem";
export class SetArticleItem extends ArticleItem {
    get isGroup() {
        return (true);
    }
    get isOfmlArticle() {
        return (false);
    }
    /**
     * Sets the label (shortText) of this set article.
     */
    setLabel(pLabel) {
        return (ArticleItem.SetShortText(this, pLabel, true));
    }
    setShortText(pText) {
        return (ArticleItem.SetShortText(this, pText, true));
    }
    setManufacturerId(pId) {
        return (ArticleItem.SetManufacturerId(this, pId));
    }
    setSeriesId(pId) {
        return (ArticleItem.SetSeriesId(this, pId));
    }
    setArticleNumber(pArticleNumber) {
        return (ArticleItem.SetArticleNumber(this, pArticleNumber));
    }
    /**
     * Sets the `collapsed` flag of this set article.
     */
    async setCollapsed(pCollapsed) {
        if (pCollapsed) {
            await this.mManager.session.basket.collapseSetArticles([this.id]);
        }
        else {
            await this.mManager.session.basket.expandSetArticles([this.id]);
        }
        return (this.updateItem(ItemUpdateFlags.ItemProps));
    }
    getSetParts() {
        const tParts = new Array();
        if (this.mItem.setArticlePartIds != null) {
            for (const tId of this.mItem.setArticlePartIds) {
                const tItem = this.mManager.getItemById(tId);
                if (tItem != null)
                    tParts.push(tItem);
                else
                    Log.warn("Unknown set part: " + tId);
            }
        }
        return (tParts);
    }
    //// protected /////////////////////////////////////////////////////////////////////////////
    generateImageUrl() {
        this.mImageUrl = "";
        return Promise.resolve();
    }
}
